let activeElement
let timeout
class NavLinkProductCards {
  constructor(navEl){
    this.id = navEl.getAttribute("data-id")
    this._cacheElements(navEl)
    this._init()
  }

  _init() {
    this.elements.link.addEventListener("mouseenter", () => this._onMouseOver())
    this.elements.dropdown.addEventListener("mouseleave", () => this._close())
  }

  _cacheElements(navEl) {
    const dropdown = navEl.closest('details[is="details-dropdown"]')
    const productCardsContainer = dropdown.querySelector(`.products__container[data-id="${this.id}"]`)
    this.elements = {
      navLink: navEl,
      link: navEl.querySelector("a"),
      productCardsContainer: productCardsContainer,
      productCards: productCardsContainer.querySelector(`.product-cards`),
      dropdown: dropdown,
      container: dropdown.querySelector(".main-container"),
    }
  }

  _close() {
    clearTimeout(timeout)
    activeElement = null
    this.hide()
    this.elements.container.style.width = 0
    this.elements.container.style.height = 0
  }

  hide() {
    this.elements.navLink.classList.remove("active")
    this.elements.productCards.style.opacity = 0
    this.elements.productCards.style.pointerEvents = "none"
  }

  _show() {
    this.elements.navLink.classList.add("active")
    this.elements.productCards.style.opacity = 1
    this.elements.productCards.style.pointerEvents = "all"
  }

  _onMouseOver() {
    clearTimeout(timeout)
    if(activeElement && activeElement.id !== this.id){
      timeout = setTimeout(() => {
        this._onMouseOver()
      }, 200)
      activeElement.hide()
      activeElement = this
      return
    }
    
    activeElement = this
    this._show()
    
    const cardBounds = this.elements.productCards.getBoundingClientRect()
    this.elements.container.style.width = cardBounds.width + 'px'
    this.elements.container.style.height = cardBounds.height + 'px'
  }
}

document.addEventListener('page:loaded', function() {
  document.querySelectorAll(".header .dropdown__nav .link-item").forEach(el => {
    if(el.hasAttribute("data-id") && el.getAttribute("data-id")){
      new NavLinkProductCards(el)
    }
  })
});